import {z} from 'zod';

import {AvailableDiscountSchema, DiscountSourceTypeSchema} from '@dms/api/shared';
import {labourTypeSchema} from '@dms/shared-aftersales';

export const LabourMechanicSchema = z.object({
  id: z.string().nullish(),
  amount: z.number().nullish(),
  ratio: z.number().nullish(),
});

export type LabourMechanic = z.infer<typeof LabourMechanicSchema>;

export const EditLabourItemFormSchema = z.object({
  serialNumber: z.number().nullish(),
  number: z.string(),
  name: z.string(),
  workType: z.string(),
  labourRateId: z.string().nullish(),
  labourCatalogId: z.string().nullish(),
  timeOutputPerUnit: z.number().nullish(),
  priceType: labourTypeSchema.nullish(),
  assignMechanics: z.array(LabourMechanicSchema),
  quantity: z.number().positive(),
  purchasePricePerUnit: z.number().nullish(),
  sellingPricePerUnit: z.number(),
  vatType: z.string(),
  vatFreeCode: z.string().nullish(),
  isUnitPriceWithVat: z.boolean(),
  isCustomPrice: z.boolean(),
  discount: z.object({
    isDoNotApplyDiscount: z.boolean(),
    isDiscountEnable: z.boolean(),
    discountSourceType: DiscountSourceTypeSchema.nullish(),
    discountRate: z.number().nullish(),
    availableDiscounts: z.array(
      AvailableDiscountSchema.extend({discountRate: z.number().min(0).max(100).nullish()})
    ),
  }),
});

export type EditLabourItemForm = z.infer<typeof EditLabourItemFormSchema>;
